

/**
 * Use in shouldComponentUpdate() to check if any props or state changed
 * @param {array} propBlacklist 
 * @param {array} stateBlacklist 
 */
export function shouldUpdate(component, nextProps, nextState, propBlacklist = [], stateBlacklist = []) {
	for (var prop in nextProps) {
		if (nextProps.hasOwnProperty(prop) && !propBlacklist.some(x => x === prop)) {
			if(nextProps[prop] !== component.props[prop]){
				return true;
			}
		}
	}

	for (var prop in nextState) {
		if (nextState.hasOwnProperty(prop) && !stateBlacklist.some(x => x === prop)) {
			if(nextState[prop] !== component.state[prop]){
				return true;
			}
		}
	}

	return false;
}




// WEBPACK FOOTER //
// ./src/utils/component.js